/**
 * PERSONEL KİMLİĞİ — ALAN DEĞERLERİ (panel kimliği ayrımı · Karar 1).
 *
 * Bu dosya `users`/`PlatformRole` katmanından TAMAMEN bağımsızdır ve öyle
 * kalmalıdır: personel rolü bir platform rolünün alt kümesi DEĞİL, ayrı bir
 * kimlik alanının kendi rolüdür. İkisi arasında hiçbir tip bağı yoktur —
 * `PlatformRole` bir gün daralsa (S3) burası etkilenmez.
 */
/**
 * Personel rolleri. `user` YOKTUR: `staff_accounts` içinde bir satır olmak
 * zaten "personel" demektir; sıradan kullanıcı bu tabloda hiç bulunmaz.
 */
export const STAFF_ROLES = ['admin', 'moderator'];
/**
 * Hesap durumu.
 * · `active`    — girebilir.
 * · `suspended` — geçici; askı kalkınca aynı hesapla geri döner (md. 1c'nin
 *                 "geri açıldı" ayağı bu değer üzerinden asertlenir).
 * · `disabled`  — kalıcı kapatma; yeniden davetle bile açılmaz, yeni hesap açılır.
 */
export const STAFF_ACCOUNT_STATUSES = ['active', 'suspended', 'disabled'];
/**
 * Tek kullanımlık kodun NİYETİ.
 * · `login` — şifre adımını geçmiş girişin ikinci faktörü (10 dk).
 * · `setup` — davet; şifresi olmayan personelin ilk kurulumu (48 saat).
 *
 * Niyet SUNUCU İÇİ değerdir; istemci gövdesi onu seçemez. `login` kodu şifre
 * bilmeden üretilemez, `setup` kodu ise yalnız bir yöneticinin daveti ile doğar.
 */
export const STAFF_OTP_PURPOSES = ['login', 'setup'];
/** Personel oturumunun neden düştüğü — denetlenebilirlik için ayrı değerler. */
export const STAFF_SESSION_REVOKE_REASONS = [
    'logout',
    'expired',
    'revoked_all',
    'reuse_detected',
    'staff_revoked',
    'account_suspended',
    'session_cap',
];
/** Davet durumu — denetlenebilir (CLAUDE.md davet kuralı: süreli + iptal edilebilir). */
export const STAFF_INVITATION_STATUSES = ['pending', 'accepted', 'revoked', 'expired'];
//# sourceMappingURL=staff-enums.js.map